export type EnvironmentTypes = 'develop' | 'staging' | 'production';

export interface LaunchDarklyEnvConfig {
  develop: string;
  staging: string;
  production: string;
}

export interface DataDogRumConfig {
  applicationId: string;
  clientToken: string;
}

export interface DataDogEnvConfig {
  develop: DataDogRumConfig;
  staging: DataDogRumConfig;
  production: DataDogRumConfig;
}

export interface ConfigurationStateInterface {
  exacteraDomainUrl: string;
  loginStackRelativeUrl: string;
  xbsEnvironment: EnvironmentTypes;
  xbsEnvironmentShort: string;
  itpUrl: string;
  proxyUrl: string;
  authUrl: string;
  launchDarklyEnv: LaunchDarklyEnvConfig;
  dataDogRumConfig: DataDogEnvConfig;
  websocketUrl: string;
}

declare global {
  interface Window {
    configuration: ConfigurationStateInterface;
  }
}

const defaultConfig: ConfigurationStateInterface = {
  exacteraDomainUrl: '',
  loginStackRelativeUrl: '',
  xbsEnvironment: 'develop',
  xbsEnvironmentShort: '',
  itpUrl: '',
  proxyUrl: '',
  authUrl: '',
  launchDarklyEnv: {
    develop: '',
    staging: '',
    production: ''
  },
  dataDogRumConfig: {
    develop: {
      applicationId: '',
      clientToken: ''
    },
    staging: {
      applicationId: '',
      clientToken: ''
    },
    production: {
      applicationId: '',
      clientToken: ''
    }
  },
  websocketUrl: ''
};

export const getAppConfig = (): ConfigurationStateInterface => window.configuration || defaultConfig;